import $ from 'jquery';

$('.Header__hamburguer').on('click', function() {
  $(this).toggleClass('active');
  $('.Sidebar').toggleClass('active');
});

$('.Sidebar__overlay').on('click', function() {
  $('.Header__hamburguer').toggleClass('active');
  $('.Sidebar').toggleClass('active');
});

$('.Sidebar__arrow').on('click', function() {
  $('.Header__hamburguer').toggleClass('active');
  $('.Sidebar').toggleClass('active');
});
